import api from "@lib/api/axios";

export async function getPrices() {
  const { data } = await api.get("/billing/prices");
  return { plans: data.plans, defaultCurrency: data.default_currency };
}

export async function createCheckoutSession(plan, currency, interval = "month") {
  const { data } = await api.post("/billing/checkout", { plan, currency, interval });
  return data.url;
}

export async function createPortalSession() {
  const { data } = await api.post("/billing/portal");
  return data.url;
}
